module.exports = __webpack_public_path__ + "static/media/Mohammed Al-Abdullah Personal Photo.e7769310.jpg";